import type { SentimentLabel } from '@/types/sentiment';
import type { RedesignThemeColors } from '@/constants/shared/theme/types';

/**
 * Theme-aware sentiment color palette: POSITIVE green, NEUTRAL white/primary,
 * NEGATIVE red. Uses redesign accent tokens so it adapts to light/dark mode.
 * Shared by the distribution line and the quotes accordion so both read the
 * same visual language.
 */
export function sentimentColor(
  redesign: RedesignThemeColors,
): Record<SentimentLabel, string> {
  return {
    positive: redesign.accent.green,
    neutral: redesign.text.primary,
    negative: redesign.accent.red,
  };
}
